import React, { useEffect } from "react";
import {
  FaUtensils,
  FaCarrot,
  FaInfoCircle,
  FaBookmark,
  FaEllipsisV,
  FaSignInAlt,
} from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/FooterNav.css";
import { supabase } from "../supabaseClient";

interface FooterNavProps {
  isLoggedIn: boolean;
  setShowLogin: React.Dispatch<React.SetStateAction<boolean>>;
  showMenu: boolean;
  setShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedTab?: (tab: string) => void;
}

const FooterNav: React.FC<FooterNavProps> = ({
  isLoggedIn,
  setShowLogin,
  showMenu,
  setShowMenu,
  setSelectedTab,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => setShowMenu((prev) => !prev);

  // 🔁 Sulje valikko aina reitin vaihtuessa (myös CI huomioitu)
  useEffect(() => {
    setShowMenu(false);
  }, [location.pathname, setShowMenu]);

  return (
    <div className="footer-nav">
      <div className="footer-blur-background" />
      <div className="footer-content">
        {isLoggedIn ? (
          <div className="nav-center">
            {/* Valikkonappi */}
            <div
              className={`nav-item ${showMenu ? "active" : ""}`}
              onClick={toggleMenu}
            >
              <FaEllipsisV className="nav-icon" aria-label="Valikko" />
            </div>

            {/* Reseptihaku */}
            <div
              className={`nav-item ${
                location.pathname === "/recipes" ? "active" : ""
              }`}
              onClick={() => navigate("/recipes")}
            >
              <FaUtensils className="nav-icon" aria-label="Reseptihaku" />
            </div>

            {/* Ruokakomero */}
            <div
              className={`nav-item ${
                location.pathname === "/storage" ? "active" : ""
              }`}
              onClick={() => navigate("/storage")}
            >
              <FaCarrot className="nav-icon" aria-label="Ruokakomero" />
            </div>

            {/* Tallennetut reseptit */}
            <div
              className={`nav-item ${
                location.pathname === "/saved" ? "active" : ""
              }`}
              onClick={() => navigate("/saved")}
            >
              <FaBookmark className="nav-icon" aria-label="Tallennetut" />
            </div>

            {/* Valikkopopup */}
            {showMenu && (
              <div className="menu-popup">
                <button
                  onClick={() => {
                    setShowMenu(false);
                    navigate("/profile");
                  }}
                >
                  Profiili
                </button>
                <button
                  onClick={() => {
                    setShowMenu(false);
                    navigate("/shopping");
                  }}
                >
                  Kauppalista
                </button>
                <button
                  onClick={() => {
                    setShowMenu(false);
                    navigate("/info");
                  }}
                >
                  Info
                </button>
                <button
                  onClick={async () => {
                    setShowMenu(false);
                    await supabase.auth.signOut();
                    navigate("/signed-out");
                  }}
                >
                  Kirjaudu ulos
                </button>
              </div>
            )}
          </div>
        ) : (
          <div className="nav-center">
            {/* Reseptit kirjautumattomalle */}
            {/* Info-painike vasemmalle */}
            <div
              className={`nav-item ${
                location.pathname === "/info" ? "active" : ""
              }`}
              onClick={() => navigate("/info")}
              aria-label="Info"
            >
              <FaInfoCircle className="nav-icon" />
            </div>
            <div
              className={`nav-item ${
                location.pathname === "/recipes" ? "active" : ""
              }`}
              onClick={() => navigate("/recipes")}
            >
              <FaUtensils className="nav-icon" aria-label="Reseptit" />
            </div>

            {/* Ruokakomero */}
            <div
              className={`nav-item ${
                location.pathname === "/storage" ? "active" : ""
              }`}
              onClick={() => navigate("/storage")}
            >
              <FaCarrot className="nav-icon" aria-label="Ruokakomero" />
            </div>

            {/* Kirjaudu */}
            <div className="nav-item" onClick={() => setShowLogin(true)}>
              <FaSignInAlt className="nav-icon" aria-label="Kirjaudu" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FooterNav;
